import { quantile } from "d3";
import { LocationScore } from "@/types";

export const extractBreaks = (scores: LocationScore[]) => {
  const values = scores.filter(x => x.rate > 0).map((x) => x.rate);
  return [
    quantile(values, 0.2) || 0,
    quantile(values, 0.4) || 0,
    quantile(values, 0.6) || 0,
    quantile(values, 0.9) || 0,
  ];
};

export const getFillColor = (breaks: number[], colors: string[]) => {
  return [
    "case",
    ["==", ["feature-state", "score"], null],
    "#ECF3F4",
    [
      "interpolate",
      ["linear"],
      ["feature-state", "score"],
      0,
      colors[0],
      breaks[0],
      colors[1],
      breaks[1],
      colors[2],
      breaks[2],
      colors[3],
      breaks[3],
      colors[4],
    ],
  ];
};
